module.exports = __webpack_public_path__ + "img/user.ee708a8d.svg";